import React from "react";
import { Navigation, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import hero1 from "../../images/slider/banner.png";
import hero2 from "../../images/page-title.jpg";
import Shape from "../../images/slider/shape-1.png";
import Shape2 from "../../images/slider/shape-2.png";
import Shape3 from "../../images/slider/shape-3.png";
import Shape4 from "../../images/slider/shape-4.png";
import Shape5 from "../../images/slider/shape-5.png";

const HeroSlider = () => {
  const slides = [
    {
      image: hero1,
      subtitle: "Injera,  Healthy Food",
      title: " ንጹህ ጤፍ እንጀራ",
      text: "100% ንጹህ የኢትዮጵያ ጤፍ",
      button: false
    },
    {
      image: hero2,
      subtitle: "በቤት ውስጥ የተሰራ እንጀራ",
      title: "",
      text: "",
      button: true
    }
  ];

  return (
    <section className="hero-slider mb-5">
      <Swiper
        modules={[Navigation, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        speed={1800}
        navigation
        className="hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div 
              className="slide-item d-flex align-items-center" 
              style={{
                backgroundImage: `url(${slide.image})`,
                height: "600px",
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%"
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 col-md-10 mx-auto text-center text-white">
                    <div className="slide-content position-relative">
                      <div className="slide-sub-title mb-3">
                        <p className="fs-4 fst-italic">
                          "<span className="fw-bold font-weight-bold fs-1">{slide.subtitle}</span>"
                        </p>
                      </div>
                      <div className="slide-title mb-4">
                        <h2 className="display-4 fw-bold h1">
                          {slide.title.split(" ")[0]} <span className="text-warning">{slide.title.split(" ").slice(1).join(" ")}</span>
                        </h2>
                      </div>
                      {slide.text && (
                        <div className="slide-text mb-4">
                          <p className="lead h1 fs-3">{slide.text}</p>
                        </div>
                      )}
                      {slide.button && (
                        <div className="slide-btns">
                          <Link to="/about" className="btn btn-warning btn-lg px-4 py-2">
                            ተጨማሪ ይወቁ
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Decorative shapes - Ethiopian traditional patterns */}
              {/* <img src={Shape} alt="" className="position-absolute top-0 start-0" style={{zIndex: 1}} />
              <img src={Shape2} alt="" className="position-absolute top-0 end-0" style={{zIndex: 1}} />
              <img src={Shape3} alt="" className="position-absolute bottom-0 start-0" style={{zIndex: 1}} />
              <img src={Shape4} alt="" className="position-absolute bottom-0 end-0" style={{zIndex: 1}} />
              <img src={Shape5} alt="" className="position-absolute" style={{top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1}} /> */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom CSS for the slider */}
      <style jsx>{`
        .hero-slider {
          position: relative;
          overflow: hidden;
        }
        .slide-item {
          position: relative;
        }
        .slide-item::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0,0,0,0.3);
          z-index: 0;
        }
        .hero-swiper .swiper-button-next,
        .hero-swiper .swiper-button-prev {
          color: white;
          background: rgba(255,255,255,0.2);
          width: 50px;
          height: 50px;
          border-radius: 50%;
          backdrop-filter: blur(5px);
        }
        .hero-swiper .swiper-button-next::after,
        .hero-swiper .swiper-button-prev::after {
          font-size: 1.5rem;
        }
        .slide-title {
          text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
        }
      `}</style>
    </section>
  );
};

export default HeroSlider;